function a(t) {
  return this.__data__.get(t);
}
var e = a;
export {
  e as default
};
//# sourceMappingURL=_stackGet.js.map
